import React, { Component } from 'react'
import { formatDate } from '../../helpers/core';
import cn from "classnames";

export default class SearchSupplierDetail extends Component {

	constructor (props) {
		super(props);
  }

  render() {
    const { detail } = this.props;

    return (
      <div className='search__supplier_detail table-responsive '>
        <table className="table table-condensed">
          <thead className="search__supplier_detail__thead">
            <tr>
              <th>Адрес</th>
              <th>Наименование</th>
              <th>Товар</th>
              <th>Звонили</th>
              <th>Позвонить</th>
              <th>НДС</th>
              <th>Без НДС</th>
              <th>Контакты</th>
              <th>Тема звонка</th>
              <th>Дополнительно</th>
            </tr>
          </thead>
          <tbody className="search__supplier_detail__tbody">
            <tr>
              <td>
                Регион:<br/>
                {detail.address}
              </td>
              <td>
                <strong  className={cn("mr-bottom-20 btn-block", {
                  "red-color": detail.in_work
                })}>{detail.name}</strong>
                {detail.categories ? detail.categories.map((category, key) => <p key={`category_${key}`}>{category.label}</p>) : null}
              </td>
              <td>
                {detail.cultures ? detail.cultures.map((culture, key) => (
                  <p key={`culture_${key}`}>
                    {culture.name}
                    {culture.price ? ` - ${culture.price}` : null}
                    {culture.volume ? `- ${culture.volume}т.` : null}
                    {culture.quality_comment ? <span className="qualiy-comment">{culture.quality_comment}</span> : null}
                  </p>
                )) : null}
              </td>
              <td>{(detail.date_called && detail.date_called.length > 0) ? formatDate(detail.date_called) : '-'}</td>
              <td>{(detail.date_will_call && detail.date_will_call.length > 0) ? formatDate(detail.date_will_call) : '-'}</td>
              <td>{detail.is_work_vat ? <i className="fi flaticon-checked"></i> : null}</td>
              <td>{detail.is_work_no_vat ? <i className="fi flaticon-checked"></i> : null}</td>
              <td>
                {
                  detail.contacts ? detail.contacts.map((contact, key) => (
                    <p key={key}>{contact.phone}<br/>{contact.name}</p>
                  )) : null
                }
              </td>
              <td>{detail.call_aim}</td>
              <td>{detail.additional_info}</td>
              </tr>
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/Search/SearchSupplierDetail.js